import React from "react";
import { Formik, Form } from "formik";
import { Box, Button, Container, Typography, FormControlLabel, Checkbox } from "@mui/material";
import { TextInput } from "../../shared/textInput/textInput";
import { ImageUploader } from "../../shared/ImageUploader/imageUploader";
import { CompanyValidationSchema } from "../../../validationSchema/companyValidationSchema";
import { Company } from "../../../interfaces/entities/company";

interface CompanyFormProps {
  title: string;
  initialValues: Company;
  onSubmit: (values: any) => Promise<void>;
  onImageChange: (file: File | null) => void;
  onClose?: () => void;
  isSubmitting: boolean;
}

export const CompanyForm: React.FC<CompanyFormProps> = ({ title, initialValues, onSubmit, onImageChange, onClose, isSubmitting }) => {
  return (
    <Box>
      <Container maxWidth="sm" className="company-form-container" >
        <div style={{ padding: '1rem', borderRadius: '8px' }}>
          <Typography variant='h5'>{title}</Typography>
          <Formik initialValues={initialValues} validationSchema={CompanyValidationSchema} validateOnMount={true}  onSubmit={onSubmit}>
            {({ values, isValid, errors, touched, handleChange, setFieldValue }) => (
              <Form>
                <TextInput label="Company Name" name="name" errorText={errors.name && touched.name ? errors.name : ""} />
                <TextInput label="Owner Email" name="email" errorText={errors.email && touched.email ? errors.email : ""} />
                <TextInput label="Contact Number" name="contact" errorText={errors.contact && touched.contact ? errors.contact : ""} />
                <TextInput label="Address" name="address" errorText={errors.address && touched.address ? errors.address : ""} /> 

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={values.config?.phoneMandatoryForReview || false}
                      onChange={(event) => setFieldValue("config.phoneMandatoryForReview", event.target.checked)}
                      name="config.phoneMandatoryForReview"
                      color="primary"
                    />
                  }
                  label="Phone mandatory for review"
                  sx={{ mt: 2 }}
                />

                <Typography variant="subtitle1" sx={{ mt: 2 }}>Company Image</Typography>
                <ImageUploader name="image" uploadedUrl={values.image} onChange={onImageChange} disabled={isSubmitting} />

                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                  <Button type="submit" variant="contained" color="primary" disabled={!isValid || isSubmitting} fullWidth className="register-button">
                    Submit
                  </Button>
                  {onClose && (
                    <Button variant="outlined" color="secondary" onClick={onClose} disabled={isSubmitting} fullWidth>
                      Close
                    </Button>
                  )}
                </Box>
              </Form>
            )}
          </Formik>
        </div>
      </Container>
    </Box>
  );
};
